import { FilterOption } from "./filters-api"

export function getfilterLabel(id: string, data?: FilterOption[]) {
  return data?.find((d) => d?.value === id)?.label
}
